import Head from 'next/head';
import { useRouter } from 'next/router';
import { BASE_WEBSITE_URL, TAB_WEB_NAME } from '@/config/constants/constants';

const SITE_URL = `https:${BASE_WEBSITE_URL}`;

const cleanValue = value => (typeof value === 'string' ? value.trim() : '');

export default function Seo({ seo }) {
  const router = useRouter();
  const seoTitle = cleanValue(seo && seo.seotitle);
  const seoDescription = cleanValue(seo && seo.seodescription);
  const seoKeywords = cleanValue(seo && seo.seokeywords);
  const title = seoTitle ? `${seoTitle} - ${TAB_WEB_NAME}` : TAB_WEB_NAME;
  const pathname = (router.asPath || '/').split('?')[0] || '/';
  const canonical = `${SITE_URL}${pathname === '/' ? '/' : `/${pathname.replace(/^\/+|\/+$/g, '')}/`}`;

  return (
    <Head>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      {seoDescription && <meta name="description" content={seoDescription} />}
      {seoDescription && <meta property="og:description" content={seoDescription} />}
      {seoKeywords && <meta name="keywords" content={seoKeywords} />}
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={`${SITE_URL}/assets/web/FB.jpg`} />
      <meta property="og:site_name" content={TAB_WEB_NAME} />
      <meta property="og:url" content={canonical} />
      <meta name="author" content={TAB_WEB_NAME} />
      <meta name="owner" content={TAB_WEB_NAME} />
    </Head>
  );
}
